import { formatDate, InputDate, InputDateProps, parseDate } from '@evaneos/b2b-ui/legacy';

export function DayPickerFormInput(
    props: Omit<InputDateProps, 'parseDate' | 'formatDate'> & { fixedWeeks?: boolean },
) {
    return (
        <InputDate format="dd/MM/yyyy" parseDate={parseDate} formatDate={formatDate} {...props} />
    );
}
